/* CrestDrives — serial picker.
 *
 * Each variant is one physical drive. Selecting a serial swaps the hidden
 * variant id that Dawn's <product-form> submits, and reveals that drive's
 * SMART report. Every report is server-rendered, so the page is correct
 * before this file runs and stays correct if it never does.
 */
(function () {
  'use strict';

  function initProduct(root) {
    var serials = root.querySelector('[data-cd-serials]');
    if (!serials) return;

    var variantInput = root.querySelector('.product-variant-id');
    var priceEl = root.querySelector('[data-cd-price]');
    var atc = root.querySelector('[data-cd-atc]');
    var atcLabel = atc ? atc.querySelector('span') : null;
    var reports = root.querySelectorAll('[data-cd-report]');
    var gradeSlot = root.querySelector('[data-cd-grade-slot]');
    var gradeLetter = root.querySelector('[data-cd-grade-letter]');

    function select(input) {
      var id = input.dataset.cdVariant;
      var available = input.dataset.cdAvailable === 'true';

      if (variantInput) {
        variantInput.value = id;
        variantInput.disabled = !available;
      }

      if (priceEl && input.dataset.cdPrice) {
        priceEl.textContent = input.dataset.cdPrice;
      }

      if (atc) {
        atc.disabled = !available;
        if (atcLabel) {
          atcLabel.textContent = available ? 'Add this drive to cart' : 'Sold';
        }
      }

      // Reveal only this drive's report.
      reports.forEach(function (report) {
        report.hidden = report.dataset.cdReport !== id;
      });

      // Keep the headline grade in step with the selected drive.
      var grade = input.dataset.cdGrade;
      if (grade) {
        if (gradeLetter) gradeLetter.textContent = grade;
        if (gradeSlot) {
          var letterEl = gradeSlot.querySelector('.cd-grade__letter');
          var chip = gradeSlot.querySelector('.cd-grade');
          if (letterEl) letterEl.textContent = grade;
          if (chip) {
            chip.classList.toggle('cd-grade--reject', grade.toLowerCase() === 'reject');
          }
        }
      }

      // Deep-linkable: share a specific drive.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url);
      }
    }

    serials.addEventListener('change', function (event) {
      var input = event.target;
      if (input && input.matches('input[type="radio"]')) select(input);
    });

    // Honour ?variant= on load so a shared link opens on the right drive.
    var requested = new URLSearchParams(window.location.search).get('variant');
    if (requested) {
      var match = serials.querySelector('input[data-cd-variant="' + requested + '"]:not(:disabled)');
      if (match) {
        match.checked = true;
        select(match);
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-cd-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Theme editor re-renders sections; re-bind when it does.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-cd-product]');
    if (root) initProduct(root);
  });
})();
